export default __webpack_public_path__ + "static/media/profileSidebarIcon_feedback.e10b9ca6.svg";